// components/Shared/RenderFlightInfo.tsx

import React, { useRef, useState } from "react";
import { Popover, PopoverBody } from "reactstrap";
import { AvailableFareSegmentModel } from "WebApiClient";

interface Props {
    segments: AvailableFareSegmentModel[];
}

export const RenderFlightInfo: React.FC<Props> = ({ segments }) => {
    const refs = useRef<(HTMLSpanElement | null)[]>([]);
    const [hoverIndex, setHoverIndex] = useState<number | null>(null);

    const handleMouseEnter = (index: number) => setHoverIndex(index);
    const handleMouseLeave = () => setHoverIndex(null);

    return (
        <>
            {segments.map((segment, index) => {
                const flightKey = `${segment.departureAirport.iata}${segment.arrivalAirport.iata}${segment.index}`;
                const fullCode = segment.carrier.code + segment.flightNumber;
                const isCodeshare = segment.codeShare && segment.codeShare.code !== fullCode;

                return (
                    <React.Fragment key={`flight-${flightKey}`}>
                        <span
                            onMouseEnter={() => handleMouseEnter(index)}
                            onMouseLeave={handleMouseLeave}
                        >
                            <span ref={(el) => (refs.current[index] = el)} id={`flight-pop-${index}`}>
                                {segment.carrier.code}
                                {segment.flightNumber}
                            </span>
                            <span className="starIcon">{isCodeshare ? "*" : ""}</span>
                            <br />
                        </span>

                        {refs.current[index] && (
                            <Popover
                                target={refs.current[index]!}
                                isOpen={hoverIndex === index}
                                className="operatedByCss"
                                placement="right"
                                toggle={() => setHoverIndex(null)}
                            >
                                <PopoverBody>
                                    Operated by: {segment.codeShare?.code || fullCode}
                                </PopoverBody>
                            </Popover>
                        )}
                    </React.Fragment>
                );
            })}
        </>
    );
};
